<ion-header class=ion-no-border>
    <ion-toolbar mode="ios">
        <ion-title>{{'Templates' | translation}}</ion-title>
        <ion-buttons slot="end">
            <ion-button size="large" fill="clear" (click)="dismiss()">
                <ion-icon name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content [scrollEvents]="true">
    <ion-list>
        <ion-list-header class="list-wrap-header">
            <ion-grid>
                <ion-row>
                    <ion-col>
                        <ion-button expand="full" shape="round" (click)="createTemplate()">
                            {{'AddTemplate' | translation}}</ion-button>
                    </ion-col>
                    <ion-col>
                        <ion-button expand="full" shape="round" (click)="displaySearch()">
                            {{'Search' | translation}}</ion-button>
                    </ion-col>
                </ion-row>
                <ion-row *ngIf="showTextArea" style="border:1px solid #cccccc">
                    <ion-col size="12">
                        <ion-input placeholder="Title" [(ngModel)]="title" style="text-transform: none;"></ion-input>
                        <ion-textarea maxlength="2000" [(ngModel)]="template" placeholder="Write here" style="text-transform: none; min-height: 70px; --padding-top: 0;--padding-bottom: 0;">
                        </ion-textarea>
                    </ion-col>
                </ion-row>
                <ion-row *ngIf="showsearch" style="border:1px solid #cccccc">
                    <ion-col size="12">
                        <ion-input placeholder="Search Template" [(ngModel)]="searchtemplate" (ionInput)="handleSearchUserTyping()" style="text-transform: none;"></ion-input>

                    </ion-col>
                </ion-row>
                <ion-row *ngIf="showTextArea" class="ion-text-right">
                    <ion-col size="12">
                        <ion-button (click)="saveTemplate()" [disabled]=" ! template">{{'Save' | translation}}
                        </ion-button>
                        <ion-button (click)="cancelTemplate()">{{'Cancel' | translation}}</ion-button>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-list-header>

        <!-- Admin Links -->
        <ion-item-divider>
            <ion-label>{{'AdminTemplates' | translation}}</ion-label>
        </ion-item-divider>
        <ion-item button *ngFor="let t of adminTemplates; let i=index" (click)="viewbodyadmin(i)">
            <p class="template-modal-template-content"><span style="font-weight: bold; font-size: small;">{{t.title}}</span><br />
                <small *ngIf="i==elemntindex && showtemplatebodyadmin ">{{t.message_template}}</small>
            </p>
            <div class="template-modal-template-buttons" slot="end">
                <ion-button (click)="dismiss(t)" shape="round" size="medium" [disabled]="plusbutton && i==elemntindex" style="margin-right: 5px; font-size: 2em;">
                    <!-- <ion-icon name="add-circle-outline" slot="icon-only"></ion-icon> -->+
                </ion-button>
                <ion-button *ngIf="t.uploaded_by != 'A'" class="small-round-btn" (click)="editTemplate($event, t)" shape="round" size="small" style="margin-right: 5px;">
                    <ion-icon name="create" slot="icon-only"></ion-icon>
                </ion-button>

                <ion-button *ngIf="t.uploaded_by != 'A'" class="small-round-btn" (click)="confirmationAlert($event, t)" color="danger" shape="round" size="small">
                    <ion-icon name="trash" slot="icon-only"></ion-icon>
                </ion-button>
            </div>
        </ion-item>

        <!-- My Links -->
        <ion-item-divider>
            <ion-label>{{'MyTemplates' | translation}}</ion-label>
        </ion-item-divider>

        <ion-reorder-group (ionItemReorder)="doLocalReorder($event)" disabled="false">
            <ion-item button *ngFor="let t of myTemplates; let i=index">
                <p (click)="dismiss(t)" class="template-modal-template-content"><span style="font-weight: bold; font-size: small;">{{t.title}}</span><br /><small *ngIf="i==elemntindex && showtemplatebody ">{{t.message_template}}</small></p>
                <div class="template-modal-template-buttons" slot="end">
                    <ion-button (click)="viewbody(i)" shape="round" size="small" style="margin-right: 5px;" 
                    [disabled]="saveOrderIsLoading">
                        <!-- <ion-icon name="add-circle-outline" slot="icon-only"></ion-icon> -->+/-
                    </ion-button>
                    <ion-button *ngIf="t.uploaded_by != 'A'" class="small-round-btn" (click)="editTemplate($event, t)" shape="round" size="small" style="margin-right: 5px;" 
                        [disabled]="saveOrderIsLoading">
                        <ion-icon name="create" slot="icon-only"></ion-icon>
                    </ion-button>

                    <ion-button *ngIf="t.uploaded_by != 'A'" class="small-round-btn" (click)="confirmationAlert($event, t)" color="danger" shape="round" size="small" 
                        [disabled]="saveOrderIsLoading">
                        <ion-icon name="trash" slot="icon-only"></ion-icon>
                    </ion-button>

                    <ion-button fill="clear" [disabled]="saveOrderIsLoading">
                        <ion-reorder>
                            <ion-icon name="arrow-up"></ion-icon>
                            <ion-icon name="arrow-down"></ion-icon>
                        </ion-reorder>
                    </ion-button>
                </div>
            </ion-item>
        </ion-reorder-group>

        <!-- <ion-item *ngFor="let t of userTemplates; let i=index">
            <p (click)="dismiss(t)">
                <span style="font-weight: bold; font-size: small;">{{t.title}}</span><br/>
                <small>{{t.message_template}}</small>
            </p>
            <div slot="end">
                <ion-button *ngIf="t.uploaded_by != 'A'" class="small-round-btn" (click)="editTemplate(t)" shape="round" size="small" style="margin-right: 5px;">
                    <ion-icon name="create" slot="icon-only"></ion-icon>
                </ion-button>

                <ion-button *ngIf="t.uploaded_by != 'A'" class="small-round-btn" (click)="confirmationAlert(t)" color="danger" shape="round" size="small">
                    <ion-icon name="trash" slot="icon-only"></ion-icon>
                </ion-button>
            </div>
        </ion-item> -->
        <ion-infinite-scroll threshold="100px" (ionInfinite)="loadMoreData($event)" [disabled]="disableLoadMore()">
            <ion-infinite-scroll-content loadingSpinner="bubbles" loadingText="{{'Loading' | translation}}">
                {{'Loading' | translation}} ...
            </ion-infinite-scroll-content>
        </ion-infinite-scroll>
    </ion-list>
</ion-content>
